import React from 'react'
import {createGlobalStyle} from 'styled-components'
import Header from "./components/Header/header.jsx"

const GlobalStyle = createGlobalStyle`
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Lato", serif;
}
`

function App() {
  return (
    <>
    <GlobalStyle />
    <Header />
    </>
  );
}

export default App;
